import { SagaIterator } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as siteListService from '../../services/siteAPI';
import { IFetchNudgeStatusRequest, IFetchSiteListRequest } from '../site/types';
import * as siteActions from './actions';
import { fetchSiteListFailure, fetchSiteListSuccess } from './actions';
import { FETCH_NUDGE_STATUS_REQUEST, FETCH_SITE_LIST_REQUEST } from './actionTypes';

/*
  Worker Saga: Fired on FETCH_REGIONS_REQUEST action
*/
export function* fetchSiteList({
  regionId,
  skip,
  limit,
  search,
  userBased,
  isHF4User,
  failureCb
}: IFetchSiteListRequest): SagaIterator {
  try {
    const {
      data: { entityList: sites, totalCount: total }
    } = yield call(siteListService.fetchSiteList as any, { regionId, limit, skip, search, userBased, isHF4User });
    const payload = { sites, total, limit };
    yield put(fetchSiteListSuccess(payload));
  } catch (e) {
    if (e instanceof Error) {
      failureCb?.(e);
      yield put(fetchSiteListFailure(e));
    }
  }
}

export function* fetchNudgeStatus(action: IFetchNudgeStatusRequest): SagaIterator {
  try {
    const {
      data: { entity: nudgeStatus }
    } = yield call(siteListService.fetchNudgeStatus, action);
    action.successCb?.(nudgeStatus);
    yield put(siteActions.fetchNudgeStatusSuccess(nudgeStatus));
  } catch (error) {
    if (error instanceof Error) {
      action.failureCb?.(error);
      yield put(siteActions.fetchNudgeStatusFailure(error));
    }
  }
}

/*
  Starts worker saga on latest dispatched specific action.
  Allows concurrent increments.
*/
function* siteSaga() {
  yield all([
    takeLatest(FETCH_SITE_LIST_REQUEST, fetchSiteList),
    takeLatest(FETCH_NUDGE_STATUS_REQUEST, fetchNudgeStatus)
  ]);
}

export default siteSaga;
